module.exports = __webpack_public_path__ + "67475a75ebeacf2d4fd8de65da936e97.MP3";